module.exports = __webpack_public_path__ + "img/times-background.0ad4e27e.png";